import React, { useEffect, useState } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animation";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import { getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import i18n from "i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import Last10GamesChart from "../../../../shared/components/LineChart/Index";
import { getTeamStats } from "../../../../shared/utils/opta/statsHandler";
import Last10GamesChartForBild from "../../../../shared/components/LineChartBild/Index";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  const [startChartAnimation, setStartChartAnimation] = useState(false);

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        console.log('animation run')
        setStartChartAnimation(true);
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if (mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener(
    //     "loadedmetadata",
    //     function () {
    //       const that = this;
    //       setTimeout(() => {
    //         outroVideo?.css("opacity", 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter);
    //     },
    //     false,
    //   );
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");
  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const last10GamesStandings = _.get(dynamic, "last10GamesStandings");
  const week = _.get(dynamic, "week");
  const totalStandingTeams = _.get(dynamic, "totalStandingTeams");

  const teamColors = {
    home: "#f1cf0e",
    away: "#df2a27",
  };

  const backgroundImage = getMainBackground(format, _.get(dynamic, "teamSide"));

  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const headline = "Tabellenverlauf"; // t("Last 10 games");

  const filteredLast10GamesStandings = last10GamesStandings.map((item) => ({
    [homeTeam?.id]: item[homeTeam?.id],
    [awayTeam?.id]: item[awayTeam?.id],
  }));
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {headline}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />
          <div className="main-content-side">
            <div className={"left-block-side"}>
              <div className="teams-block">
                <div className={`team-logo-container`}>
                  <BildTeamLogo className="team-logo" id={homeTeam?.id} />
                </div>
                <div className={`team-name`}>
                  {t(homeTeam?.name, {
                    ns: "countries",
                  })}
                </div>
              </div>
              <div className="left-block-shadow"></div>
            </div>
            <div className={"center-block-side"}>
              <div className={"pitch-container"}>
                {
                  last10GamesStandings && last10GamesStandings.length > 0 && <Last10GamesChartForBild
                    competitionId={12}
                    homeTeam={homeTeam}
                    awayTeam={awayTeam}
                    standings={filteredLast10GamesStandings}
                    teamColors={teamColors}
                    week={week}
                    totalStandingTeams={totalStandingTeams}
                    startChartAnimation={startChartAnimation}
                  />
                }

              </div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
